const COLLECTIONS = {
  left_menu: {
    method: 'GET',
    url: '/main_menu',
  },
  left_menu_settings: {
    method: 'GET',
    url: '/data/main_menu/settings',
  },

  // Tag Realms
  realms_list: {
    method: 'GET',
    url: '/data/ts/realm/list',
  },
  realms_realm: {
    method: 'GET',
    url: '/data/ts/tag/list/',
  },
  realms_create: {
    method: 'POST',
    url: '/data/ts/realm/create/',
  },
  realms_delete: {
    method: 'GET',
    url: '/data/ts/realm/delete/',
  },

  // Tag realm tags
  tag_create: {
    method: 'POST',
    url: '/data/ts/tag/create/',
  },
  tag_delete: {
    method: 'GET',
    url: '/data/ts/tag/delete/',
  },
  tag_recommend: {
    method: 'POST',
    url: '/data/ts/tag/recommend/',
  },

  // Document Browser - Saved Filters
  docbrowser_get_saved_filters: {
    method: 'GET',
    url: '/data/iql/saved',
  },
  docbrowser_filters_save: {
    method: 'GET',
    url: '/data/iql/save_filter',
  },
  docbrowser_filters_delete: {
    method: 'GET',
    url: '/data/iql/delete/',
  },
  docbrowser_items_list: {
    method: 'GET',
    url: '/data/documents',
  },
  docbrowser_items_copypages: {
    method: 'GET',
    url: '/data/documents/copies',
  },
  docbrowser_items_columns: {
    method: 'GET',
    url: '/data/documents/columns',
  },
  docbrowser_categories: {
    method: 'GET',
    url: '/data/categories',
  },
  docbrowser_directories: {
    method: 'GET',
    url: '/data/directories',
  },
  docbrowser_filters_chips: {
    method: 'GET',
    url: '/data/iql/chips',
  },
  docbrowser_iql_convert: {
    method: 'GET',
    url: '/data/iql/convert',
  },
  docbrowser_info_panel: {
    method: 'GET',
    url: '/data/documents/info',
  },
  docbrowser_focus_point: {
    method: 'GET',
    url: '/data/documents/focus_area/show',
  },
  docbrowser_focus_point_save: {
    method: 'GET',
    url: '/data/documents/focus_area/save',
  },
  docbrowser_history: {
    method: 'GET',
    url: '/data/documents/history',
  },
  docbrowser_archive_versions: {
    method: 'GET',
    url: '/data/documents/archive_versions',
  },
  docbrowser_references: {
    method: 'GET',
    url: '/data/documents/references',
  },
  docbrowser_publish_status: {
    method: 'GET',
    url: '/data/documents/publish_status',
  },
  docbrowser_variants: {
    method: 'GET',
    url: '/data/documents/variants/show',
  },
  docbrowser_variants_set_default: {
    method: 'GET',
    url: '/data/documents/variants/set_default',
  },
  docbrowser_variants_set_description: {
    method: 'GET',
    url: '/data/documents/variants/set_description',
  },
  docbrowser_differences: {
    method: 'GET',
    url: '/data/documents/differences',
  },
  docbrowser_customize: {
    method: 'GET',
    url: '/document/media/customize/assets',
  },
  docbrowser_upload_assets: {
    method: 'POST',
    url: '/document/media/upload/upload',
  },
  docbrowser_upload_assets_status: {
    method: 'GET',
    url: '/document/media/upload/display',
  },
  docbrowser_upload_assets_check: {
    method: 'GET',
    url: '/document/media/upload/check',
  },
  docbrowser_live_uri: {
    method: 'GET',
    url: '/data/documents/live_uri',
  },
  docbrowser_paste_restrictions: {
    method: 'GET',
    url: '/data/copy/check_restrictions',
  },
  docbrowser_paste_documents: {
    method: 'GET',
    url: '/data/copy/paste',
  },
  docbrowser_change_dates: {
    method: 'GET',
    url: '/data/meta/document_dates',
  },
  docbrowser_upload_restrictions: {
    method: 'GET',
    url: '/data/upload/upload_restrictions',
  },
};

export default COLLECTIONS;
